var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "content",
      class: { "base-sortable-list--scrollable": _vm.isScrollable },
      attrs: { "data-component": "base-sortable-list" },
      on: { scroll: _vm.onScroll },
    },
    [
      _vm._l(_vm.model, function (item, index) {
        return _c(
          "div",
          {
            key: item.vforkey,
            staticClass: "base-sortable-list-item",
            attrs: { draggable: _vm.isReordable && !_vm.handle },
          },
          [
            _vm._t("item", null, null, {
              index: index,
              props: item,
              items: _vm.model,
              deleteItem: _vm.deleteItem,
              addItem: _vm.addItem,
            }),
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm._t("footer", null, { addItem: _vm.addItem }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }